import React from 'react';
import ReactDOM from 'react-dom';

const Loader = () => {
  const el = document.querySelector('#loader');
  if (!el) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-white dark:bg-gray-900/70 backdrop-blur-sm">
      {/* Logo icon + spinner ring */}
      <div className="relative flex items-center justify-center">
        {/* Spinning ring */}
        <svg
          className="absolute animate-spin"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
        >
          <circle
            cx="32"
            cy="32"
            r="28"
            stroke="#e0e7ff"
            strokeWidth="4"
          />
          <circle
            cx="32"
            cy="32"
            r="28"
            stroke="#3b82f6"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="44 132"
            strokeDashoffset="0"
          />
        </svg>
        {/* Logo center */}
        <img
          src="/logo.png"
          alt="3sual.az"
          className="w-10 h-10 object-contain drop-shadow-lg"
        />
      </div>
    </div>,
    el
  );
};

export default Loader;